import React from "react";
import Status from "../../../../model2/status/status";

type Props = {
    className?: string,
    status: Status
}

export default function TaskStatusSelector_Form(props: Props) {


    const curValueClasses = Classes('cur-value', 'form', 'gd-scf-'+props.status.color);

    return (
        <div className={curValueClasses}>

            <div className="name">{props.status.name}</div>
            <span className="i5-big-angle-down"> </span>

        </div>
    );

}
